module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "focus-warp",
    style: (_vm.style)
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('Carousel', {
    attrs: {
      "autoplay": _vm.setting.autoplay,
      "autoplay-speed": _vm.setting.autoplaySpeed,
      "dots": _vm.setting.dots,
      "radius-dot": _vm.setting.radiusDot,
      "trigger": _vm.setting.trigger,
      "arrow": _vm.setting.arrow,
      "height": _vm.height || 496
    },
    on: {
      "on-change": _vm.change
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }, _vm._l((_vm.data), function(item) {
    return _c('CarouselItem', {
      key: item.key
    }, [_c('router-link', {
      staticClass: "img-box",
      attrs: {
        "to": item.url,
        "target": "_blank"
      }
    }, [_c('img', {
      staticClass: "img-item",
      attrs: {
        "src": item.atturl,
        "height": "496px",
        "width": "100%"
      }
    })])], 1)
  }), 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-43193ecd"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/enterprise-brand-store/banner.vue
// module id = 1590
// module chunks = 1